var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header",style:([
		{
			'background-color': _vm.current_prop.color
			,'color': _vm.current_prop.text_color
		},
	])},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.item.id))]),_c('span',[_vm._v(_vm._s(_vm.item.district))]),_c('span',[_vm._v(_vm._s(_vm.item.name))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.waterlevel))]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.current_prop.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }